import React from "react";

function fpgAdminOnlyicon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9.8" height="13.72" viewBox="0 0 10 14">
      <image width="10" height="14" href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAA30lEQVQokY3RPUrDQRAF8J9/BS0C2tlY+lGksPMQVim09gYewN5TeAuRQAoPIViIZRBBLfwg8SNiIqOzuEnlg4H3dt7szOzOTTo7hzjCALu49otFnGMDvYUkqxnL/jCPNlaw2eC+Sg4r/oGn5K9hHFXJsWkUPQzjc4pPvFe2L7wV/t8bB01VNap4QdHjJlsGJhk1iv6ZMbYrqGec0vGOj7nQ7cy8gTh7QT9+Jg628ZCJGi2s4zJaH+AMXaxVrviZE5ziOFp30hCxhZs0LmEvx9uPG6OijwtczSwSXe7Q/QbOAT24S0UlSAAAAABJRU5ErkJggg=="/>
    </svg>
  );
}

export default fpgAdminOnlyicon;
